









































































import moment from 'moment-timezone'
import { UserActionContexts } from '@/constants/urls'
import {
  PatientManagementWizardDetailedPatientInformationKeys as PatientInformationKeys,
  VibePackageDeviceTypes as PackageDeviceTypes,
} from '@/constants/patients'
import { VsaList, VsaItem, VsaHeading, VsaContent, VsaIcon } from 'vue-simple-accordion'
import 'vue-simple-accordion/dist/vue-simple-accordion.css'

export default {
  props: {
    patientNoun: {
      type: String,
      required: true,
    },
    patientInformation: {
      type: Object,
      required: true,
    },
    packageVibe: {
      // todo compare this to [PackageDeviceTypes.Vibe]...
      type: Object,
      default: null,
    },
    userActionContext: {
      type: String,
      required: true,
    },
    [PackageDeviceTypes.Vibe]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Gateway]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Tracker]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Inhaler]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.PulseOximeter]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Scale]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Thermometer]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Bpm]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Glucometer]: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    contextIsNew() {
      return this.userActionContext === UserActionContexts.New
    },
    newVibeId() {
      return this[PackageDeviceTypes.Vibe]
    },
    formattedDateOfBirth() {
      if (this.patientInformation[PatientInformationKeys.DateOfBirth]) {
        return moment(this.patientInformation[PatientInformationKeys.DateOfBirth]).format('DD-MM-YYYY')
      }
      return ''
    },
    stageDescriptionText() {
      let newVibeId = this[PackageDeviceTypes.Vibe]
      if (this.contextIsNew) {
        ;`Great! You've added all the information for your new ${this.patientNoun.toLowerCase()}${
          newVibeId ? ' and package ID' : ''
        }. Now just double check the details and you're good to go.`
      }
      return `Here is your updated ${this.patientNoun.toLowerCase()} information. Now just double check the details and you're good to go.`
    },
    informationSummary() {
      let cg = this.patientInformation[PatientInformationKeys.CareGiver]
      return [
        {
          label: 'First Name',
          value: this.patientInformation[PatientInformationKeys.FirstName],
        },
        {
          label: 'Last Name',
          value: this.patientInformation[PatientInformationKeys.LastName],
        },
        {
          label: 'Birth Date',
          value: this.formattedDateOfBirth,
        },
        {
          label: 'Phone Number',
          value: this.patientInformation[PatientInformationKeys.PhoneNumber],
        },
        {
          label: 'Care Giver',
          value: cg.firstName + ' ' + cg.lastName,
        },
        {
          label: 'Inhaler Type',
          value: this.patientInformation[PatientInformationKeys.InhalerType],
        },
      ].map(item => ({
        ...item,
        value: item.value ? item.value : '-',
      }))
    },
    packageSummary() {
      return [
        {
          label: 'Modem',
          value: this[PackageDeviceTypes.Gateway],
        },
        {
          label: 'Tracker',
          value: this[PackageDeviceTypes.Tracker],
        },
        {
          label: 'Inhaler',
          value: this[PackageDeviceTypes.Inhaler],
        },
        {
          label: 'Pulse Oximeter',
          value: this[PackageDeviceTypes.PulseOximeter],
        },
        {
          label: 'Scale',
          value: this[PackageDeviceTypes.Scale],
        },
        {
          label: 'Thermometer',
          value: this[PackageDeviceTypes.Thermometer],
        },
        {
          label: 'BPM',
          value: this[PackageDeviceTypes.Bpm],
        },
        {
          label: 'Glucometer',
          value: this[PackageDeviceTypes.Glucometer],
        },
      ].map(item => ({
        ...item,
        value: item.value ? item.value : '-',
      }))
    },
  },
}
